// @flow
import * as React from 'react';
import { trackClicked } from 'utils/analytics';
import SearchPageContainer from 'containers/SearchPageContainer';
import MainSearchContainer from 'containers/MainSearchContainer';
import PostListingLink from 'components/PostListingLink';
import { SecondaryButtonRouterLink } from 'components/Button';
import ClientOnly from 'containers/ClientOnly';

const { useState } = React;

const LandingPage = () => {
  const [searchMode, setSearchMode] = useState(true);
  return (
    <ClientOnly>
      <SearchPageContainer
        hero={{
          id: 'main-home-search',
          name: 'main-home-search',
          created: '0-0-0',
          type: 'MAIN_SEARCH',
          text: /* TRANSLATORS: Home page search header */ getText(
            'Find the perfect opportunity to change the world.'
          ),
          image: null,
          cta: (
            <PostListingLink
              component={SecondaryButtonRouterLink}
              reverse
              size="small"
              onClick={() => {
                trackClicked('Post A Listing', { context: 'Hero' });
              }}
            >
              {getText('Hiring? Post a Job')}
            </PostListingLink>
          )
        }}
        results={<MainSearchContainer showListingCounts />}
        navSection="MAIN"
        searchMode={searchMode}
        darkMode
        setSearchMode={setSearchMode}
        showListingCounts
        url={{ en: '/en/', es: '/es/', pt: '/pt/' }}
      />
    </ClientOnly>
  );
};

export default LandingPage;
